import { render, staticRenderFns } from "./LiveratesConfigurations.vue?vue&type=template&id=460410d1&scoped=true"
import script from "./LiveratesConfigurations.vue?vue&type=script&lang=js"
export * from "./LiveratesConfigurations.vue?vue&type=script&lang=js"
import style0 from "./LiveratesConfigurations.vue?vue&type=style&index=0&id=460410d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460410d1",
  null
  
)

export default component.exports